const localeByLanguage = {
  en: "en-US",
  sr: "sr-Latn-RS",
};

export const getNewsDateSource = (news) => news?.date_iso || news?.date;

export const getLocalizedNewsDate = (news, language = "en") => {
  if (!news) return "";

  if (language === "sr" && news.date_sr) return news.date_sr;
  if (language === "en" && news.date_en) return news.date_en;

  const source = getNewsDateSource(news);
  if (!source) return "";

  const parsedDate = new Date(source);
  if (Number.isNaN(parsedDate.valueOf())) return source;

  return new Intl.DateTimeFormat(localeByLanguage[language] || "en-US", {
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(parsedDate);
};

export const getNewsDateParts = (news, language = "en") => {
  const source = getNewsDateSource(news);
  const parsedDate = source ? new Date(source) : null;
  const hasValidDate = parsedDate && !Number.isNaN(parsedDate.valueOf());

  if (!hasValidDate) {
    return { day: "", month: "" };
  }

  return {
    day: parsedDate.getDate(),
    month: parsedDate.toLocaleString(localeByLanguage[language] || "en-US", {
      month: "short",
    }),
  };
};
